
import { Options } from "vue-class-component";
import Page from "../molecules/Page.vue";
import ActionButton from "../atoms/ActionButton.vue";
import UserSelector from "../molecules/UserSelector.vue";
import DepartmentUserSelector from "../organisms/DepartmentUserSelector.vue";
import PersonalityMatrixChart from "../atoms/PersonalityMatrixChart.vue";
import { SelectableProfile, GetPersonalityMatrix, GetProfile } from "../../types";
import { StatsItemEnum } from "../../autogen";
import { print } from "../../helpers/view-utils";
import ChartViewMixin from "../../helpers/mixins/chart-view";

@Options({
  components: {
    Page,
    ActionButton,
    UserSelector,
    DepartmentUserSelector,
    PersonalityMatrixChart
  }
})
export default class PersonalityMatrix extends ChartViewMixin {
  selectedUsers: SelectableProfile[] = [];
  stats: (GetPersonalityMatrix & GetProfile)[] = [];
  activePath = "main";
  participantsMin = 1;
  participantsMax = 100;
  targetStats = StatsItemEnum.PersonalityMatrix;
  departmentUserSelectorFormKey = 0;
  tutorialImagePath = require("@/assets/image/PMatrixTutorial.png");
  async onSelectionDone() {
    this.stats = this.selectedUsers.map(selectedUser =>
      Object.assign(this.chartData![selectedUser.id].profile, this.chartData![selectedUser.id].stats["PersonalityMatrix"], {
        id: selectedUser.id
      })
    );
  }
  onPrintButtonClick() {
    print(StatsItemEnum.PersonalityMatrix, this.stats);
  }
}
